import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtag from 'vue-gtag'
import Store from '@/store/index.js'
import smoothscroll from 'smoothscroll-polyfill';
import { isExpired } from '../plugins/auth'

smoothscroll.polyfill();

Vue.use(VueRouter)

// 全権限共通のroute
const routes = [
  {
    path: '/sign_in',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue')
  },
  {
    path: '/admin/sign_in',
    name: 'AdminSignIn',
    component: () => import('../views/SignIn.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue')
  },
  {
    path: '/not_found',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },
  {
    path: '/env_check',
    name: 'EnvCheck',
    component: () => import('../views/EnvCheck.vue')
  },
  {
    path: '/lost_password',
    name: 'LostPassword',
    component: () => import('../views/LostPassword.vue')
  }
]

// 権限ごとのrouteを読み込む
const files = require.context('.', false, /\.js$/)
files.keys().reduce((routes, filename) => {
  if (filename === './index.js') return routes

  const addRoutes = files(filename).default
  const namespace = filename.replace(/(\.\/|\.js)/g, '')

  addRoutes.forEach(route => {
    const componentName = route.name;
    route.path = '/' + namespace + route.path;
    route.component = () => import(`../views/${namespace}/${componentName}.vue`);
    // 権限ごとのrouteでnameが被るとエラーになるのでnameをnamespaceを使って書き換えておく
    route.name = namespace + route.name;

    routes.push(route)
  })

  return routes
}, routes)

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // ルートpathは/sign_in
  if (to.path === '/') {
    next('/sign_in')
  }

  // お客様No.照合画面、 動作環境チェック画面、管理者ログイン画面、パスワード再設定画面への遷移は許容
  else if (to.path === '/enrollment' || to.path === '/env_check' || to.path === '/admin/sign_in' || to.path === '/lost_password') {
    Store.commit('setCurrentPath', { path: to.path })
    next()
  }

  // 申込関連画面はお客様No.の照合を行っていないと遷移させない
  else if (to.path.includes('/enrollment')) {
    if (!Store.state.enrollment.clientCode) {
      next('/enrollment')
    } else {
      next()
    }
  }

  // ログインしていなかったらsign_in画面へ遷移させる
  else if (to.name !== 'SignIn' && !Store.state.user.accessToken) {
    Store.commit('setCurrentPath', { path: '/sign_in' })
    next('/sign_in')
  }

  // 一定時間操作がなかったらログアウトさせる
  else if (isExpired()) {
    Vue.prototype.$axios.delete('/api/v1/auth/sign_out')
      .catch(() => {})
  }

  // pdfプレビュー画面はurlがsaved_print&gid=1&pid=1のようになっている。
  // この時リロードされたら&以降を削除
  else if (to.path.includes('gid') || to.path.includes('pid')) {
    const index = to.path.indexOf('&')
    next(to.path.slice(0, index))
  }

  // adminでログイン中にteacherがつくURLへ遷移 or teacherでログイン中にadminがつくURLへ遷移
  // => 404 NotFound
  else if (Store.getters['user/isAdmin'] && to.path.includes('teacher')) { next('/not_found') }
  else if (Store.getters['user/isTeacher'] && to.path.includes('admin')) { next('/not_found') }
  // 存在しないページへ遷移 => 404 NotFound
  else if (!router.options.routes.find(route => route.name === to.name)) { next('/not_found') }
  else {
    // menuアイコンがアクティブならfalseにする
    if (Store.state.drawer) Store.commit('setDrawer', { drawer: false })
    Store.commit('setCurrentPath', { path: to.path })
    Store.commit('user/setLastOperatedDate', { lastOperatedDate: new Date })
    next()
  }
})

Vue.use(VueGtag, {
  config: {id: process.env.VUE_APP_GA_ID},
  params: {
    send_page_view: false
  }
}, router);

export default router
